import { CommonModule } from '@angular/common';
import { Component, ElementRef, input, output, viewChild } from '@angular/core';
import { HeaderComponent } from '@app/components/base/header.component';
import { CategoryGroup } from '@app/models/category-group';
import { environment } from '@environment/environment';

import { IconComponent } from '../../icon/icon.component';
import { AppsStarterComponent } from '../apps-starter/apps-starter.component';
import { HamburgerBottomNavComponent } from './hamburger-bottom-nav/hamburger-bottom-nav.component';

@Component({
  selector: 'app-hamburger',
  imports: [AppsStarterComponent, CommonModule, HamburgerBottomNavComponent, IconComponent],
  templateUrl: './hamburger.component.html',
  styleUrls: ['./hamburger.component.scss']
})
export class HamburgerComponent extends HeaderComponent {
  public categoriesGroups = input<CategoryGroup[] | null>();
  public categoryGroup = input<string | null>();
  public dialog = viewChild<ElementRef | undefined>('appHamburgerDialog');
  public navigationTrigger = output<void>();
  public version: string = environment.version;

  public openDialog(): void {
    this.dialog()?.nativeElement.showModal();
    document.body.style.overflow = 'hidden';
  }

  public closeDialog($event?: MouseEvent): void {
    $event?.preventDefault();
    this.dialog()?.nativeElement.close();
    document.body.style.overflow = '';
  }

  public onNavigationClick(url: string | null, $event: Event): void {
    $event.preventDefault();

    const dialogElement = this.dialog()?.nativeElement;
    if (!dialogElement) {
      if (url) {
        this.navigateToUrl(url);
      }
      return;
    }

    // Close the dialog first
    dialogElement.close();

    // Listen for the dialog close event to ensure it's fully closed before navigation
    const handleDialogClose = (): void => {
      dialogElement.removeEventListener('close', handleDialogClose);
      this.navigationTrigger.emit();
      if (url) {
        this.navigateToUrl(url);
      }
    };

    dialogElement.addEventListener('close', handleDialogClose);

    // Fallback: if close event doesn't fire within 150ms, proceed anyway
    setTimeout(() => {
      dialogElement.removeEventListener('close', handleDialogClose);
      this.navigationTrigger.emit();
      if (url) {
        this.navigateToUrl(url);
      }
    }, 150);
  }

  private navigateToUrl(url: string): void {
    this.router.navigateByUrl(url);
    this.changeDetectorRef.detectChanges();
  }
}
